import { render, staticRenderFns } from "./Gara.vue?vue&type=template&id=1e1ff360&scoped=true&"
import script from "./Gara.vue?vue&type=script&lang=js&"
export * from "./Gara.vue?vue&type=script&lang=js&"
import style0 from "./Gara.vue?vue&type=style&index=0&id=1e1ff360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1ff360",
  null
  
)

export default component.exports